export default function disjoint(values, other) {
  const iterator = other[Symbol.iterator](), set = new Set();
  for (const v of values) {
    if (set.has(v)) return false;
    let value, done;
    while (({value, done} = iterator.next())) {
      if (done) break;
      if (Object.is(v, value)) return false;
      set.add(value);
    }
  }
  return true;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/disjoint.js
// module id = 2055
// module chunks = 0